"use client";
import { useState, useEffect } from "react";
import Link from "next/link";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const fetchConsent = async () => {
      const response = await fetch("/api/cookie");
      const data = await response.json();
      if (!data.consent) {
        const timer = setTimeout(() => {
          setOpen(true);
        }, 500);
        return () => clearTimeout(timer);
      }
    };
    fetchConsent();
  }, []);

  const handleDecline = async () => {
    setOpen(false);
    await fetch("/api/cookie", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ consent: "declined" }),
    });
  };

  const handleAllow = async () => {
    setOpen(false);
    await fetch("/api/cookie", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ consent: "allowed" }),
    });
  };

  return (
    <div className="w-full">
      {open && (
        <div
          className="fixed flex flex-row max-w-screen-3xl mx-auto bottom-10 inset-x-5 bg-white p-5 rounded-lg shadow-2xl gap-4 flex-wrap md:flex-nowrap text-center md:text-left items-center justify-center md:justify-between transition transform ease-in-out scale-100 opacity-100"
          style={{ transition: "all 0.3s ease", zIndex: 9999999999999 }}
        >
          <div className="flex text-slate-900 items-justify-center md:justify-start">
            <span>
              This website uses cookies to ensure you get the best experience on
              our website.{" "}
              <Link
                href="/privacy-policy"
                className="text-blue-700 hover:underline"
              >
                Learn more about our privacy policy
              </Link>
            </span>
          </div>
          <div className="flex gap-4 items-center flex-shrink-0 ml-auto justify-end">
            <button
              onClick={handleDecline}
              className="px-5 py-3 text-blue-700 focus:outline-none hover:underline overflow-hidden"
            >
              Decline
            </button>
            <button
              onClick={handleAllow}
              className="bg-blue-700 px-5 py-3 text-white rounded-md hover:bg-indigo-700 focus:outline-none"
            >
              Allow Cookies
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
